export enum DefaultRoutePermissions {
    Files = 'files',
    RequestList = 'request-list',
    Settings = 'settings',
    Payment = 'payment',
    Teams = 'teams',
    Templates = 'templates',
    Contacts = 'contacts',
    Account = 'account',
    Security = 'security',
    Branding = 'branding',
    Integrations = 'Integrations',
}
